import WindowModal from './WindowModal';
import { ContentProviderAjaxDjangoFetch, RESPONSE_JSON_WITH_HTML } from '../lib/modals/content_providers/ContentProviderAjax';

class AjaxModal extends WindowModal {

  constructor(ajaxUrl) {
    super(new ContentProviderAjaxDjangoFetch(ajaxUrl, {method: 'GET'}, RESPONSE_JSON_WITH_HTML));
  }

}

export default AjaxModal;



// WEBPACK FOOTER //
// ./src/js/modals/AjaxModal.js